import {
    SUBSCRIPTIONS_REQUEST,
    SUBSCRIPTIONS_SUCCESS,
    SUBSCRIPTIONS_FAILURE,
    SUBSCRIPTION_REQUEST,
    SUBSCRIPTION_SUCCESS,
    SUBSCRIPTION_FAILURE,
    SUBSCRIPTION_CANCEL_SUCCESS,
    UPDATE_SUBSCRIPTIONS,
    QUIT_SHARING_SUCCESS,
    GET_SUBSCRIPTION_DELIVERY_REQUEST,
    GET_SUBSCRIPTION_DELIVERY_SUCCESS,
    GET_SUBSCRIPTION_DELIVERY_FAILURE,
} from './types';

const initialState = {
    subscriptionsList: [],
    pending: true,
    error: false,
    message: '',
    subscription: {},
    subscriptionPending: true,
    subscriptionError: false,
    subscriptionMessage: '',
};

const removeSubscriptionsByIds = (subscriptions, subscriptionsToRemove) =>
    subscriptions.filter(({ id: subscriptionId }) =>
        !subscriptionsToRemove.find(({ id: subscriptionToRemoveId }) => subscriptionToRemoveId === subscriptionId));

const modifySubscriptionsOnCancel = {
    CANCELED: (subscriptions, { data: { subscriptionsToRemove, subscriptionsToUpdate } }) => {
        const removedSubscriptions = removeSubscriptionsByIds(subscriptions, subscriptionsToRemove);
        const removedDublicatedSubscriptions = removedSubscriptions.reduce((subscriptionsList, subscription) => {
            const foundTheSameSubscription = subscriptionsList.find(({ id }) => id === subscription.id);
            return [...subscriptionsList, ...(foundTheSameSubscription ? [] : [subscription])];
        }, []);
        const updatedSubscriptions = removedDublicatedSubscriptions.map(
            subscription => subscriptionsToUpdate.find(({ id }) => id === subscription.id) || subscription
        );
        return updatedSubscriptions;
    },
};

const modifySingleSubscriptionOnCancel = (subscription = {}, { data: { subscriptionsToUpdate = [] } }) =>
    subscriptionsToUpdate.find(({ id }) => id === subscription.id) || subscription;

const modifySingleSubscription = (currentSubscription = {}, subscriptionsToUpdate = []) =>
    subscriptionsToUpdate.find(sub => sub.id === currentSubscription.id) || currentSubscription;

const modifySubscriptionsOnSharingQuit = (subscriptions = [], { subscriptionId }) =>
    subscriptions.filter(subscription => subscription.id !== subscriptionId);

const modifySubscriptionDelivery = (subscriptions = [], { subscriptionId, delivery }) =>
    subscriptions.map(subscription => (
        subscription.id === subscriptionId
            ? {
                ...subscription,
                delivery,
            }
            : subscription
    ));

export default (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case SUBSCRIPTION_CANCEL_SUCCESS:
            return {
                ...state,
                subscriptionsList: modifySubscriptionsOnCancel[payload.status](state.subscriptionsList, payload),
                subscription: modifySingleSubscriptionOnCancel(
                    state.subscription,
                    payload
                ),
            };
        case UPDATE_SUBSCRIPTIONS:
            return {
                ...state,
                subscriptionsList: [
                    ...removeSubscriptionsByIds(state.subscriptionsList, payload),
                    ...payload,
                ],
                subscription: modifySingleSubscription(state.subscription, payload),
            };
        case QUIT_SHARING_SUCCESS:
            return {
                ...state,
                subscriptionsList: modifySubscriptionsOnSharingQuit(state.subscriptionsList, payload),
            };
        case GET_SUBSCRIPTION_DELIVERY_REQUEST:
            return {
                ...state,
                subscriptionsList: modifySubscriptionDelivery(state.subscriptionsList, {
                    subscriptionId: action?.payload?.subscriptionId,
                    delivery: {
                        fetching: true,
                        success: false,
                    },
                }),
            };
        case GET_SUBSCRIPTION_DELIVERY_SUCCESS:
            return {
                ...state,
                subscriptionsList: modifySubscriptionDelivery(state.subscriptionsList, {
                    subscriptionId: action?.payload?.subscriptionId,
                    delivery: {
                        ...action?.payload?.data?.present,
                        fetching: false,
                        success: true,
                    },
                }),
            };
        case GET_SUBSCRIPTION_DELIVERY_FAILURE:
            return {
                ...state,
                subscriptionsList: modifySubscriptionDelivery(state.subscriptionsList, {
                    subscriptionId: action?.meta?.subscriptionId,
                    delivery: {
                        fetching: false,
                        success: false,
                    },
                }),
            };
        case SUBSCRIPTIONS_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case SUBSCRIPTIONS_SUCCESS:
            return {
                ...state,
                subscriptionsList: action.payload.data ? action.payload.data : action.payload,
                pending: false,
            };
        case SUBSCRIPTIONS_FAILURE:
            return {
                ...state,
                error: true,
                pending: false,
                message: action.payload.response.message,
            };
        case SUBSCRIPTION_REQUEST:
            return {
                ...state,
                subscription: {},
                subscriptionPending: true,
                subscriptionError: false,
                fetchedSubscriptionId: payload?.subscriptionId,
            };
        case SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                subscription: action.payload.data ? action.payload.data : action.payload,
                subscriptionPending: false,
            };
        case SUBSCRIPTION_FAILURE:
            return {
                ...state,
                subscriptionError: true,
                subscriptionPending: false,
                subscriptionMessage: action.payload.response.message,
            };
        default:
            return state;
    }
};
